import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {MaskFabricDefaultBox} from "./mask-fabric.default.box";
import {MaskFabricCasino777Box} from "./mask-fabric.casino777.box";
import {MaskFabricMrGreenBox} from "./mask-fabric.mrgreen.box";
import {MaskFabricSIBox} from "./mask-fabric.si.box";

export const MaskFabricBox = styledByTheme(MaskFabricDefaultBox)
    .forMrGreen(MaskFabricMrGreenBox)
    .forCasino777(MaskFabricCasino777Box)
    .forSI(MaskFabricSIBox)
    .apply();